export const mock_divisions = {
  onPage: 1,
  pageSize: 50,
  totalPages: 1,
  totalRecords: 23,
  data: [
    {
      id: null,
      divisionCode: "GTM",
      divisionDescription: "GUATEMALA",
    },
    {
      id: null,
      divisionCode: "NZL",
      divisionDescription: "NEW ZEALAND",
    },
    {
      id: null,
      divisionCode: "EMEA",
      divisionDescription: "EMEA",
    },
    {
      id: null,
      divisionCode: "CHL",
      divisionDescription: "CHILE",
    },
    {
      id: null,
      divisionCode: "PRI",
      divisionDescription: "PUERTO RICO",
    },
    {
      id: null,
      divisionCode: "CHN",
      divisionDescription: "CHINA",
    },
    {
      id: null,
      divisionCode: "KCNA",
      divisionDescription: "Kimberly Clark North America",
    },
    {
      id: null,
      divisionCode: "NIC",
      divisionDescription: "NICARAGUA",
    },
    {
      id: null,
      divisionCode: "THA",
      divisionDescription: "THAILAND",
    },
    {
      id: null,
      divisionCode: "COL1",
      divisionDescription: "COLOMBIA",
    },
    {
      id: null,
      divisionCode: "BRA",
      divisionDescription: "BRAZIL",
    },
    {
      id: null,
      divisionCode: "RUS",
      divisionDescription: "RUSSIA",
    },
    {
      id: null,
      divisionCode: "YK",
      divisionDescription: "YUHAN KIMBERLY (KOR)",
    },
    {
      id: null,
      divisionCode: "ARG",
      divisionDescription: "ARGENTINA",
    },
    {
      id: null,
      divisionCode: "ECU",
      divisionDescription: "ECUADOR",
    },
    {
      id: null,
      divisionCode: "CRI",
      divisionDescription: "COSTA RICA",
    },
    {
      id: null,
      divisionCode: "*DFT",
      divisionDescription: "DEFAULT DIVISION",
    },
    {
      id: null,
      divisionCode: "PAN",
      divisionDescription: "PANAMA",
    },
    {
      id: null,
      divisionCode: "PER",
      divisionDescription: "PERU",
    },
    {
      id: null,
      divisionCode: "SLV",
      divisionDescription: "EL SALVADOR",
    },
    {
      id: null,
      divisionCode: "BOL",
      divisionDescription: "BOLIVIA",
    },
    {
      id: null,
      divisionCode: "AUS",
      divisionDescription: "AUSTRALIA",
    },
    {
      id: null,
      divisionCode: "HND",
      divisionDescription: "HONDURAS",
    },
  ],
};

export const mock_countries = {
  onPage: 1,
  pageSize: 500,
  totalPages: 1,
  totalRecords: 251,
  data: [
    {
      countryCode: "USA",
      name: "UNITED STATES",
    },
    {
      countryCode: "ABW",
      name: "ARUBA",
    },
    {
      countryCode: "AFG",
      name: "AFGHANISTAN",
    },
    {
      countryCode: "AGO",
      name: "ANGOLA",
    },
    {
      countryCode: "AIA",
      name: "ANGUILLA",
    },
    {
      countryCode: "ALA",
      name: "ALAND ISLANDS",
    },
    {
      countryCode: "ALB",
      name: "ALBANIA",
    },
    {
      countryCode: "AND",
      name: "ANDORRA",
    },
    {
      countryCode: "ANT",
      name: "NETHERLANDS ANTILLES (DO NOT USE) (USE 'BES')",
    },
    {
      countryCode: "ARE",
      name: "UNITED ARAB EMIRATES",
    },
    {
      countryCode: "ARG",
      name: "ARGENTINA",
    },
    {
      countryCode: "ARM",
      name: "ARMENIA",
    },
    {
      countryCode: "ASM",
      name: "AMERICAN SAMOA",
    },
    {
      countryCode: "ATA",
      name: "ANTARCTICA",
    },
    {
      countryCode: "ATF",
      name: "FRENCH SOUTHERN TERRITORIES",
    },
    {
      countryCode: "ATG",
      name: "ANTIGUA AND BARBUDA",
    },
    {
      countryCode: "AUS",
      name: "AUSTRALIA",
    },
    {
      countryCode: "AUT",
      name: "AUSTRIA",
    },
    {
      countryCode: "AZE",
      name: "AZERBAIJAN",
    },
    {
      countryCode: "BDI",
      name: "BURUNDI",
    },
    {
      countryCode: "BEL",
      name: "BELGIUM",
    },
    {
      countryCode: "BEN",
      name: "BENIN",
    },
    {
      countryCode: "BES",
      name: "BONAIRE, SABA",
    },
    {
      countryCode: "BFA",
      name: "BURKINA FASO",
    },
    {
      countryCode: "BGD",
      name: "BANGLADESH",
    },
    {
      countryCode: "BGR",
      name: "BULGARIA",
    },
    {
      countryCode: "BHR",
      name: "BAHRAIN",
    },
    {
      countryCode: "BHS",
      name: "BAHAMAS",
    },
    {
      countryCode: "BIH",
      name: "BOSNIA AND HERZEGOWINA",
    },
    {
      countryCode: "BLM",
      name: "ST BARTHELEMY",
    },
    {
      countryCode: "BLR",
      name: "BELARUS",
    },
    {
      countryCode: "BLZ",
      name: "BELIZE",
    },
    {
      countryCode: "BMU",
      name: "BERMUDA",
    },
    {
      countryCode: "BOL",
      name: "BOLIVIA",
    },
    {
      countryCode: "BRA",
      name: "BRAZIL",
    },
    {
      countryCode: "BRB",
      name: "BARBADOS",
    },
    {
      countryCode: "BRN",
      name: "BRUNEI DARUSSALAM",
    },
    {
      countryCode: "BTN",
      name: "BHUTAN",
    },
    {
      countryCode: "BVT",
      name: "BOUVET ISLAND",
    },
    {
      countryCode: "BWA",
      name: "BOTSWANA",
    },
    {
      countryCode: "CAF",
      name: "CENTRAL AFRICAN REPUBLIC",
    },
    {
      countryCode: "CAN",
      name: "CANADA",
    },
    {
      countryCode: "CCK",
      name: "COCOS  KEELING  ISLANDS",
    },
    {
      countryCode: "CHE",
      name: "SWITZERLAND",
    },
    {
      countryCode: "CHL",
      name: "CHILE",
    },
    {
      countryCode: "CHN",
      name: "CHINA",
    },
    {
      countryCode: "CIV",
      name: "COTE D'IVOIRE",
    },
    {
      countryCode: "CMR",
      name: "CAMEROON",
    },
    {
      countryCode: "COD",
      name: "CONGO, THE DEMOCRATIC REPUBLIC OF THE",
    },
    {
      countryCode: "COG",
      name: "CONGO",
    },
    {
      countryCode: "COK",
      name: "COOK ISLANDS",
    },
    {
      countryCode: "COL",
      name: "COLOMBIA",
    },
    {
      countryCode: "COM",
      name: "COMOROS",
    },
    {
      countryCode: "CPV",
      name: "CAPE VERDE",
    },
    {
      countryCode: "CRI",
      name: "COSTA RICA",
    },
    {
      countryCode: "CUB",
      name: "CUBA",
    },
    {
      countryCode: "CUW",
      name: "CURACAO",
    },
    {
      countryCode: "CXR",
      name: "CHRISTMAS ISLAND",
    },
    {
      countryCode: "CYM",
      name: "CAYMAN ISLANDS",
    },
    {
      countryCode: "CYP",
      name: "CYPRUS",
    },
    {
      countryCode: "CZE",
      name: "CZECH REPUBLIC",
    },
    {
      countryCode: "DEU",
      name: "GERMANY",
    },
    {
      countryCode: "DJI",
      name: "DJIBOUTI",
    },
    {
      countryCode: "DMA",
      name: "DOMINICA",
    },
    {
      countryCode: "DNK",
      name: "DENMARK",
    },
    {
      countryCode: "DOM",
      name: "DOMINICAN REPUBLIC",
    },
    {
      countryCode: "DZA",
      name: "ALGERIA",
    },
    {
      countryCode: "ECU",
      name: "ECUADOR",
    },
    {
      countryCode: "EGY",
      name: "EGYPT",
    },
    {
      countryCode: "ERI",
      name: "ERITREA",
    },
    {
      countryCode: "ESH",
      name: "WESTERN SAHARA",
    },
    {
      countryCode: "ESP",
      name: "SPAIN",
    },
    {
      countryCode: "EST",
      name: "ESTONIA",
    },
    {
      countryCode: "ETH",
      name: "ETHIOPIA",
    },
    {
      countryCode: "FIN",
      name: "FINLAND",
    },
    {
      countryCode: "FJI",
      name: "FIJI",
    },
    {
      countryCode: "FLK",
      name: "FALKLAND ISLANDS  MALVINAS",
    },
    {
      countryCode: "FRA",
      name: "FRANCE",
    },
    {
      countryCode: "FRO",
      name: "FAROE ISLANDS",
    },
    {
      countryCode: "FSM",
      name: "MICRONESIA, FEDERATED STATES OF",
    },
    {
      countryCode: "FXX",
      name: "FRANCE, METROPOLITAN (DO NOT USE)",
    },
    {
      countryCode: "GAB",
      name: "GABON",
    },
    {
      countryCode: "GBR",
      name: "UNITED KINGDOM",
    },
    {
      countryCode: "GEO",
      name: "GEORGIA",
    },
    {
      countryCode: "GHA",
      name: "GHANA",
    },
    {
      countryCode: "GIB",
      name: "GIBRALTAR",
    },
    {
      countryCode: "GIN",
      name: "GUINEA",
    },
    {
      countryCode: "GLP",
      name: "GUADELOUPE",
    },
    {
      countryCode: "GMB",
      name: "GAMBIA",
    },
    {
      countryCode: "GNB",
      name: "GUINEA-BISSAU",
    },
    {
      countryCode: "GNQ",
      name: "EQUATORIAL GUINEA",
    },
    {
      countryCode: "GRC",
      name: "GREECE",
    },
    {
      countryCode: "GRD",
      name: "GRENADA",
    },
    {
      countryCode: "GRL",
      name: "GREENLAND",
    },
    {
      countryCode: "GTM",
      name: "GUATEMALA",
    },
    {
      countryCode: "GUF",
      name: "FRENCH GUIANA",
    },
    {
      countryCode: "GUM",
      name: "GUAM",
    },
    {
      countryCode: "GUY",
      name: "GUYANA",
    },
    {
      countryCode: "HKG",
      name: "HONG KONG",
    },
    {
      countryCode: "HMD",
      name: "HEARD AND MC DONALD ISLANDS",
    },
    {
      countryCode: "HND",
      name: "HONDURAS",
    },
    {
      countryCode: "HRV",
      name: "CROATIA  local name: Hrvatska",
    },
    {
      countryCode: "HTI",
      name: "HAITI",
    },
    {
      countryCode: "HUN",
      name: "HUNGARY",
    },
    {
      countryCode: "IDN",
      name: "INDONESIA",
    },
    {
      countryCode: "IND",
      name: "INDIA",
    },
    {
      countryCode: "IOT",
      name: "BRITISH INDIAN OCEAN TERRITORY",
    },
    {
      countryCode: "IRL",
      name: "IRELAND",
    },
    {
      countryCode: "IRN",
      name: "IRAN  ISLAMIC REPUBLIC OF",
    },
    {
      countryCode: "IRQ",
      name: "IRAQ",
    },
    {
      countryCode: "ISL",
      name: "ICELAND",
    },
    {
      countryCode: "ISR",
      name: "ISRAEL",
    },
    {
      countryCode: "ITA",
      name: "ITALY",
    },
    {
      countryCode: "JAM",
      name: "JAMAICA",
    },
    {
      countryCode: "JOR",
      name: "JORDAN",
    },
    {
      countryCode: "JPN",
      name: "JAPAN",
    },
    {
      countryCode: "KAZ",
      name: "KAZAKHSTAN",
    },
    {
      countryCode: "KEN",
      name: "KENYA",
    },
    {
      countryCode: "KGZ",
      name: "KYRGYZSTAN",
    },
    {
      countryCode: "KHM",
      name: "CAMBODIA",
    },
    {
      countryCode: "KIR",
      name: "KIRIBATI",
    },
    {
      countryCode: "KNA",
      name: "SAINT KITTS AND NEVIS",
    },
    {
      countryCode: "KOR",
      name: "KOREA, REPUBLIC OF",
    },
    {
      countryCode: "KOS",
      name: "KOSOVO (DO NOT USE)",
    },
    {
      countryCode: "KWT",
      name: "KUWAIT",
    },
    {
      countryCode: "LAO",
      name: "LAO PEOPLE'S DEMOCRATIC REPUBLIC",
    },
    {
      countryCode: "LBN",
      name: "LEBANON",
    },
    {
      countryCode: "LBR",
      name: "LIBERIA",
    },
    {
      countryCode: "LBY",
      name: "LIBYAN ARAB JAMAHIRIYA",
    },
    {
      countryCode: "LCA",
      name: "SAINT LUCIA",
    },
    {
      countryCode: "LIE",
      name: "LIECHTENSTEIN",
    },
    {
      countryCode: "LKA",
      name: "SRI LANKA",
    },
    {
      countryCode: "LSO",
      name: "LESOTHO",
    },
    {
      countryCode: "LTU",
      name: "LITHUANIA",
    },
    {
      countryCode: "LUX",
      name: "LUXEMBOURG",
    },
    {
      countryCode: "LVA",
      name: "LATVIA",
    },
    {
      countryCode: "MAC",
      name: "MACAU",
    },
    {
      countryCode: "MAF",
      name: "SAINT MARTIN",
    },
    {
      countryCode: "MAR",
      name: "MOROCCO",
    },
    {
      countryCode: "MCO",
      name: "MONACO",
    },
    {
      countryCode: "MDA",
      name: "MOLDOVA, REPUBLIC OF",
    },
    {
      countryCode: "MDG",
      name: "MADAGASCAR",
    },
    {
      countryCode: "MDV",
      name: "MALDIVES",
    },
    {
      countryCode: "MEX",
      name: "MEXICO",
    },
    {
      countryCode: "MHL",
      name: "MARSHALL ISLANDS",
    },
    {
      countryCode: "MKD",
      name: "MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF",
    },
    {
      countryCode: "MLI",
      name: "MALI",
    },
    {
      countryCode: "MLT",
      name: "MALTA",
    },
    {
      countryCode: "MMR",
      name: "MYANMAR",
    },
    {
      countryCode: "MNE",
      name: "MONTENEGRO",
    },
    {
      countryCode: "MNG",
      name: "MONGOLIA",
    },
    {
      countryCode: "MNP",
      name: "NORTHERN MARIANA ISLANDS",
    },
    {
      countryCode: "MOZ",
      name: "MOZAMBIQUE",
    },
    {
      countryCode: "MRT",
      name: "MAURITANIA",
    },
    {
      countryCode: "MSR",
      name: "MONTSERRAT",
    },
    {
      countryCode: "MTQ",
      name: "MARTINIQUE",
    },
    {
      countryCode: "MUS",
      name: "MAURITIUS",
    },
    {
      countryCode: "MWI",
      name: "MALAWI",
    },
    {
      countryCode: "MYS",
      name: "MALAYSIA",
    },
    {
      countryCode: "MYT",
      name: "MAYOTTE",
    },
    {
      countryCode: "NAM",
      name: "NAMIBIA",
    },
    {
      countryCode: "NCL",
      name: "NEW CALEDONIA",
    },
    {
      countryCode: "NER",
      name: "NIGER",
    },
    {
      countryCode: "NFK",
      name: "NORFOLK ISLAND",
    },
    {
      countryCode: "NGA",
      name: "NIGERIA",
    },
    {
      countryCode: "NIC",
      name: "NICARAGUA",
    },
    {
      countryCode: "NIU",
      name: "NIUE",
    },
    {
      countryCode: "NLD",
      name: "NETHERLANDS",
    },
    {
      countryCode: "NOR",
      name: "NORWAY",
    },
    {
      countryCode: "NPL",
      name: "NEPAL",
    },
    {
      countryCode: "NRU",
      name: "NAURU",
    },
    {
      countryCode: "NZL",
      name: "NEW ZEALAND",
    },
    {
      countryCode: "OMN",
      name: "OMAN",
    },
    {
      countryCode: "PAK",
      name: "PAKISTAN",
    },
    {
      countryCode: "PAN",
      name: "PANAMA",
    },
    {
      countryCode: "PCN",
      name: "PITCAIRN",
    },
    {
      countryCode: "PER",
      name: "PERU",
    },
    {
      countryCode: "PHL",
      name: "PHILIPPINES",
    },
    {
      countryCode: "PLW",
      name: "PALAU",
    },
    {
      countryCode: "PNG",
      name: "PAPUA NEW GUINEA",
    },
    {
      countryCode: "POL",
      name: "POLAND",
    },
    {
      countryCode: "PRI",
      name: "PUERTO RICO",
    },
    {
      countryCode: "PRK",
      name: "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF",
    },
    {
      countryCode: "PRT",
      name: "PORTUGAL",
    },
    {
      countryCode: "PRY",
      name: "PARAGUAY",
    },
    {
      countryCode: "PYF",
      name: "FRENCH POLYNESIA",
    },
    {
      countryCode: "QAT",
      name: "QATAR",
    },
    {
      countryCode: "REU",
      name: "REUNION",
    },
    {
      countryCode: "ROM",
      name: "ROMANIA (DO NOT USE) (USE 'ROU')",
    },
    {
      countryCode: "ROU",
      name: "ROMANIA",
    },
    {
      countryCode: "RUS",
      name: "RUSSIAN FEDERATION",
    },
    {
      countryCode: "RWA",
      name: "RWANDA",
    },
    {
      countryCode: "SAU",
      name: "SAUDI ARABIA",
    },
    {
      countryCode: "SDN",
      name: "SUDAN",
    },
    {
      countryCode: "SEN",
      name: "SENEGAL",
    },
    {
      countryCode: "SGP",
      name: "SINGAPORE",
    },
    {
      countryCode: "SGS",
      name: "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS",
    },
    {
      countryCode: "SHN",
      name: "ST. HELENA",
    },
    {
      countryCode: "SJM",
      name: "SVALBARD AND JAN MAYEN ISLANDS",
    },
    {
      countryCode: "SLB",
      name: "SOLOMON ISLANDS",
    },
    {
      countryCode: "SLE",
      name: "SIERRA LEONE",
    },
    {
      countryCode: "SLV",
      name: "EL SALVADOR",
    },
    {
      countryCode: "SMR",
      name: "SAN MARINO",
    },
    {
      countryCode: "SOM",
      name: "SOMALIA",
    },
    {
      countryCode: "SPM",
      name: "ST. PIERRE AND MIQUELON",
    },
    {
      countryCode: "SRB",
      name: "SERBIA",
    },
    {
      countryCode: "SSD",
      name: "SOUTH SUDAN",
    },
    {
      countryCode: "STP",
      name: "SAO TOME AND PRINCIPE",
    },
    {
      countryCode: "SUR",
      name: "SURINAME",
    },
    {
      countryCode: "SVK",
      name: "SLOVAKIA  Slovak Republic",
    },
    {
      countryCode: "SVN",
      name: "SLOVENIA",
    },
    {
      countryCode: "SWE",
      name: "SWEDEN",
    },
    {
      countryCode: "SWZ",
      name: "SWAZILAND",
    },
    {
      countryCode: "SXM",
      name: "SINT MAARTEN",
    },
    {
      countryCode: "SYC",
      name: "SEYCHELLES",
    },
    {
      countryCode: "SYR",
      name: "SYRIAN ARAB REPUBLIC",
    },
    {
      countryCode: "TCA",
      name: "TURKS AND CAICOS ISLANDS",
    },
    {
      countryCode: "TCD",
      name: "CHAD",
    },
    {
      countryCode: "TGO",
      name: "TOGO",
    },
    {
      countryCode: "THA",
      name: "THAILAND",
    },
    {
      countryCode: "TJK",
      name: "TAJIKISTAN",
    },
    {
      countryCode: "TKL",
      name: "TOKELAU",
    },
    {
      countryCode: "TKM",
      name: "TURKMENISTAN",
    },
    {
      countryCode: "TLS",
      name: "TIMOR-LESTE",
    },
    {
      countryCode: "TON",
      name: "TONGA",
    },
    {
      countryCode: "TTO",
      name: "TRINIDAD AND TOBAGO",
    },
    {
      countryCode: "TUN",
      name: "TUNISIA",
    },
    {
      countryCode: "TUR",
      name: "TURKEY",
    },
    {
      countryCode: "TUV",
      name: "TUVALU",
    },
    {
      countryCode: "TWN",
      name: "TAIWAN, PROVINCE OF CHINA",
    },
    {
      countryCode: "TZA",
      name: "TANZANIA, UNITED REPUBLIC OF",
    },
    {
      countryCode: "UGA",
      name: "UGANDA",
    },
    {
      countryCode: "UKR",
      name: "UKRAINE",
    },
    {
      countryCode: "UMI",
      name: "UNITED STATES MINOR OUTLYING ISLANDS",
    },
    {
      countryCode: "URY",
      name: "URUGUAY",
    },
    {
      countryCode: "UZB",
      name: "UZBEKISTAN",
    },
    {
      countryCode: "VAT",
      name: "HOLY SEE  VATICAN CITY STATE",
    },
    {
      countryCode: "VCT",
      name: "SAINT VINCENT AND THE GRENADINES",
    },
    {
      countryCode: "VEN",
      name: "VENEZUELA",
    },
    {
      countryCode: "VGB",
      name: "VIRGIN ISLANDS  BRITISH",
    },
    {
      countryCode: "VIR",
      name: "VIRGIN ISLANDS  U.S.",
    },
    {
      countryCode: "VNM",
      name: "VIET NAM",
    },
    {
      countryCode: "VUT",
      name: "VANUATU",
    },
    {
      countryCode: "WLF",
      name: "WALLIS AND FUTUNA ISLANDS",
    },
    {
      countryCode: "WSM",
      name: "SAMOA",
    },
    {
      countryCode: "YEM",
      name: "YEMEN",
    },
    {
      countryCode: "YUG",
      name: "YUGOSLAVIA (DO NOT USE)",
    },
    {
      countryCode: "ZAF",
      name: "SOUTH AFRICA",
    },
    {
      countryCode: "ZAR",
      name: "DEMOCRATIC REPUBLIC OF CONGO (DO NOT USE) (USE 'COD')",
    },
    {
      countryCode: "ZMB",
      name: "ZAMBIA",
    },
    {
      countryCode: "ZWE",
      name: "ZIMBABWE",
    },
  ],
};

export const mock_cities = [
  {
    id: null,
    cityId: "1461841",
    shippingLocationType: "Distribution Center",
    shippingLocationCode: "30131316",
    shippingLocationDescription: "RAAF - Edinburgh (92 Wing)",
    shippingLocationStatus: "Active",
    cityAddress: {
      id: null,
      cityCode: "-",
      country: null,
      postalCode: "5111",
      city: null,
      state: null,
    },
  },
  {
    id: null,
    cityId: "1461880",
    shippingLocationType: "Distribution Center",
    shippingLocationCode: "30131385",
    shippingLocationDescription: "Resthaven - Marion",
    shippingLocationStatus: "Active",
    cityAddress: {
      id: null,
      cityCode: "-",
      country: null,
      postalCode: "5043",
      city: null,
      state: null,
    },
  },
  {
    id: null,
    cityId: "1461890",
    shippingLocationType: "Distribution Center",
    shippingLocationCode: "30131423",
    shippingLocationDescription: "Resthaven - Leabrook",
    shippingLocationStatus: "Active",
    cityAddress: {
      id: null,
      cityCode: "-",
      country: null,
      postalCode: "5068",
      city: null,
      state: null,
    },
  },
  {
    id: null,
    cityId: "1462023",
    shippingLocationType: "Distribution Center",
    shippingLocationCode: "30131645",
    shippingLocationDescription: "Adrian Thomas Industrial",
    shippingLocationStatus: "Active",
    cityAddress: {
      id: null,
      cityCode: "-",
      country: null,
      postalCode: "5277",
      city: null,
      state: null,
    },
  },
  {
    id: null,
    cityId: "47450",
    shippingLocationType: "Distribution Center",
    shippingLocationCode: "30410009",
    shippingLocationDescription: "KCP DISPENSERS NSW",
    shippingLocationStatus: "Active",
    cityAddress: {
      id: null,
      cityCode: ".",
      country: null,
      postalCode: "2061",
      city: null,
      state: null,
    },
  },
];

export const mock_zones = [
  {
    zoneId: "150461",
    zoneCode: "150461",
    zoneDescription: "150461",
    countryCode: "COL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "1T18",
    zoneCode: "1T18",
    zoneDescription: "ITALY 18001 to 18999",
    countryCode: "ITA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "2061",
    zoneCode: "2061",
    zoneDescription: "Milsons Point",
    countryCode: "AUS",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40000801",
    zoneCode: "40000801",
    zoneDescription: "OPERADORA DEL ORIENTE S.A. DE C.V.",
    countryCode: "HND",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40000853",
    zoneCode: "40000853",
    zoneDescription: "CEDI - OPERADORA DEL ORIENTE",
    countryCode: "HND",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40004306",
    zoneCode: "40004306",
    zoneDescription: "WM CR",
    countryCode: "CRI",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40032525",
    zoneCode: "40032525",
    zoneDescription: "DISCOGRA SAN ANDRES CONSUMO",
    countryCode: "COL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40033991",
    zoneCode: "40033991",
    zoneDescription: "PUNTO BLANCO S.A.C. PIURA",
    countryCode: "PER",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40060320",
    zoneCode: "40060320",
    zoneDescription: "PRISA S.A.",
    countryCode: "CHL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40064816",
    zoneCode: "40064816",
    zoneDescription: "CENTRO DE DISTRIBUCION GUATEMALA",
    countryCode: "GTM",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40065883",
    zoneCode: "40065883",
    zoneDescription: "SUPERMERCADO XTRA",
    countryCode: "PAN",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40072272",
    zoneCode: "40072272",
    zoneDescription: "OPERADORA DEL SUR S.A. DE C.V",
    countryCode: "SLV",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40072571",
    zoneCode: "40072571",
    zoneDescription: "PUNTO BLANCO S.A.C. TUMBES",
    countryCode: "PER",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40073211",
    zoneCode: "40073211",
    zoneDescription: "ALMACENES LA SELVA JAEN",
    countryCode: "PER",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40077998",
    zoneCode: "40077998",
    zoneDescription: "GLOSER S.A.C. ANDAHUAYLAS",
    countryCode: "PER",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40081847",
    zoneCode: "40081847",
    zoneDescription: "PORTO RESTRIÇÃO",
    countryCode: "BRA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40084171",
    zoneCode: "40084171",
    zoneDescription: "CALLEJA S.A. DE C.V.",
    countryCode: "SLV",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40089795",
    zoneCode: "40089795",
    zoneDescription: "SAM'S DC KCP 6271",
    countryCode: "PRI",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40093187",
    zoneCode: "40093187",
    zoneDescription: "DISTRIBUIDORA MOLI S.A.C ",
    countryCode: "PER",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40095081",
    zoneCode: "40095081",
    zoneDescription: "SUPERMERCADO JUNIOR",
    countryCode: "HND",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40110082",
    zoneCode: "40110082",
    zoneDescription: "WAL MART ARGENTINA SRL",
    countryCode: "ARG",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40145898",
    zoneCode: "40145898",
    zoneDescription: "PRICESMART BARRANQUILLA",
    countryCode: "COL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40162159",
    zoneCode: "40162159",
    zoneDescription: "D1 CEDI EJE CAFETERO",
    countryCode: "COL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40162160",
    zoneCode: "40162160",
    zoneDescription: "D1 CEDI TOCANCIPA",
    countryCode: "COL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40162952",
    zoneCode: "40162952",
    zoneDescription: "DESPENSA PERUANA CHICLAYO",
    countryCode: "PER",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40165372",
    zoneCode: "40165372",
    zoneDescription: "DISTRIBUIDORA GABRIELA EMPRESA IND",
    countryCode: "PER",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40165906",
    zoneCode: "40165906",
    zoneDescription: "PRICESMART MEDELLIN",
    countryCode: "COL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40165907",
    zoneCode: "40165907",
    zoneDescription: "PRICESMART PEREIRA",
    countryCode: "COL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40167669",
    zoneCode: "40167669",
    zoneDescription: "D1 CEDI VALLE DEL CAUCA",
    countryCode: "COL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40168095",
    zoneCode: "40168095",
    zoneDescription: "SARAHI",
    countryCode: "HND",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40168222",
    zoneCode: "40168222",
    zoneDescription: "DOLLAR CITY RANSA",
    countryCode: "SLV",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40168570",
    zoneCode: "40168570",
    zoneDescription: "WALMART CHILLAN",
    countryCode: "CHL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40168571",
    zoneCode: "40168571",
    zoneDescription: "WALMART TEMUCO",
    countryCode: "CHL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40168572",
    zoneCode: "40168572",
    zoneDescription: "WALMART CHILE LO AGUIRRE",
    countryCode: "CHL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40168573",
    zoneCode: "40168573",
    zoneDescription: "WALMART ANTOFAGASTA",
    countryCode: "CHL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40169580",
    zoneCode: "40169580",
    zoneDescription: "D1 CEDI FUNZA",
    countryCode: "COL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40169750",
    zoneCode: "40169750",
    zoneDescription: "TOTTUS MAIPU",
    countryCode: "CHL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40170935",
    zoneCode: "40170935",
    zoneDescription: "CORPORACION SAN RAFAELITO J ",
    countryCode: "PER",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40170992",
    zoneCode: "40170992",
    zoneDescription: "OLGUIN QUILICURA",
    countryCode: "CHL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40172045",
    zoneCode: "40172045",
    zoneDescription: "D1 CEDI SOACHA",
    countryCode: "COL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40173126",
    zoneCode: "40173126",
    zoneDescription: "HOMECENTER LIMA NORTE",
    countryCode: "PER",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40174137",
    zoneCode: "40174137",
    zoneDescription: "SODIMAC LIMA SUR",
    countryCode: "PER",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40175323",
    zoneCode: "40175323",
    zoneDescription: "OLGUIN TALCA",
    countryCode: "CHL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40177086",
    zoneCode: "40177086",
    zoneDescription: "SUPER MARKET ISLA COLON",
    countryCode: "PAN",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40178741",
    zoneCode: "40178741",
    zoneDescription: "DESPENSA DE LA SELVA - IQUITOS",
    countryCode: "PER",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40179644",
    zoneCode: "40179644",
    zoneDescription: "WALMART SAN BERNARDO",
    countryCode: "CHL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40179666",
    zoneCode: "40179666",
    zoneDescription: "PRICESMART CR",
    countryCode: "CRI",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40180144",
    zoneCode: "40180144",
    zoneDescription: "COMERCIAL SCRUCIAL WORLD",
    countryCode: "CHL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40180218",
    zoneCode: "40180218",
    zoneDescription: "CARLOS MAURICIO DIAZ RIOS",
    countryCode: "CHL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40180821",
    zoneCode: "40180821",
    zoneDescription: "GLOSER S.A.C. - ABANCAY",
    countryCode: "PER",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40185392",
    zoneCode: "40185392",
    zoneDescription: "COMERCIAL SCRUCIAL WORLD",
    countryCode: "CHL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40185418",
    zoneCode: "40185418",
    zoneDescription: "(E) DROGUERIA INRETAIL - SANTA ANITA",
    countryCode: "PER",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40185419",
    zoneCode: "40185419",
    zoneDescription: "(S) DROGUERIA INRETAIL - CHORRILLOS",
    countryCode: "PER",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40185469",
    zoneCode: "40185469",
    zoneDescription: "ALMACENES DE LA SELVA - LA BANDA DE",
    countryCode: "PER",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40186282",
    zoneCode: "40186282",
    zoneDescription: "D1 CEDI IBAGUE",
    countryCode: "COL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40186287",
    zoneCode: "40186287",
    zoneDescription: "GLOSER SAC - AYACUCHO",
    countryCode: "PER",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40187806",
    zoneCode: "40187806",
    zoneDescription: "ALMACENES DE LA SELVA PUCALLPA 3",
    countryCode: "PER",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40187846",
    zoneCode: "40187846",
    zoneDescription: "GLOSER SAC (LA MAR AYNA)",
    countryCode: "PER",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40188618",
    zoneCode: "40188618",
    zoneDescription: "DESPENSA PERUANA TRUJILLO HUANCHACO",
    countryCode: "PER",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40189277",
    zoneCode: "40189277",
    zoneDescription: "INRETAIL PHARMA– CD PIURA",
    countryCode: "PER",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40190513",
    zoneCode: "40190513",
    zoneDescription: "DISCOGRA SAN ANDRES KCP",
    countryCode: "COL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40190552",
    zoneCode: "40190552",
    zoneDescription: "PSMT CENTRALIZADO PANAMA",
    countryCode: "PAN",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "40191311",
    zoneCode: "40191311",
    zoneDescription: "TOTTUS PUDAHUEL",
    countryCode: "CHL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "44000056",
    zoneCode: "44000056",
    zoneDescription: "WALMART CHILE CARRUSELL",
    countryCode: "CHL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "44000066",
    zoneCode: "44000066",
    zoneDescription: "WALMART CHILE SAN BERNARDO CARRUSELL",
    countryCode: "CHL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "44000075",
    zoneCode: "44000075",
    zoneDescription: "URBANO",
    countryCode: "CHL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "500001",
    zoneCode: "500001",
    zoneDescription: "500001",
    countryCode: "COL",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99501",
    zoneCode: "5AK99501",
    zoneDescription: "AK ZIP 99501",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99502",
    zoneCode: "5AK99502",
    zoneDescription: "AK ZIP 99502",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99503",
    zoneCode: "5AK99503",
    zoneDescription: "AK ZIP 99503",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99504",
    zoneCode: "5AK99504",
    zoneDescription: "AK ZIP 99504",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99507",
    zoneCode: "5AK99507",
    zoneDescription: "AK ZIP 99507",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99508",
    zoneCode: "5AK99508",
    zoneDescription: "AK ZIP 99508",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99515",
    zoneCode: "5AK99515",
    zoneDescription: "AK ZIP 99515",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99516",
    zoneCode: "5AK99516",
    zoneDescription: "AK ZIP 99516",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99517",
    zoneCode: "5AK99517",
    zoneDescription: "AK ZIP 99517",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99518",
    zoneCode: "5AK99518",
    zoneDescription: "AK ZIP 99518",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99577",
    zoneCode: "5AK99577",
    zoneDescription: "AK ZIP 99577",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99603",
    zoneCode: "5AK99603",
    zoneDescription: "AK ZIP 99603",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99611",
    zoneCode: "5AK99611",
    zoneDescription: "AK ZIP 99611",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99615",
    zoneCode: "5AK99615",
    zoneDescription: "AK ZIP 99615",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99623",
    zoneCode: "5AK99623",
    zoneDescription: "AK ZIP 99623",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99645",
    zoneCode: "5AK99645",
    zoneDescription: "AK ZIP 99645",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99654",
    zoneCode: "5AK99654",
    zoneDescription: "AK ZIP 99654",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99664",
    zoneCode: "5AK99664",
    zoneDescription: "AK ZIP 99664",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99669",
    zoneCode: "5AK99669",
    zoneDescription: "AK ZIP 99669",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99692",
    zoneCode: "5AK99692",
    zoneDescription: "AK ZIP 99692",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99701",
    zoneCode: "5AK99701",
    zoneDescription: "AK ZIP 99701",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99705",
    zoneCode: "5AK99705",
    zoneDescription: "AK ZIP 99705",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99709",
    zoneCode: "5AK99709",
    zoneDescription: "AK ZIP 99709",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99731",
    zoneCode: "5AK99731",
    zoneDescription: "AK ZIP 99731",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99801",
    zoneCode: "5AK99801",
    zoneDescription: "AK ZIP 99801",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99833",
    zoneCode: "5AK99833",
    zoneDescription: "AK ZIP 99833",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99835",
    zoneCode: "5AK99835",
    zoneDescription: "AK ZIP 99835",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99901",
    zoneCode: "5AK99901",
    zoneDescription: "AK ZIP 99901",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AK99926",
    zoneCode: "5AK99926",
    zoneDescription: "AK ZIP 99926",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AL35001",
    zoneCode: "5AL35001",
    zoneDescription: "AL Zip 35001",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AL35002",
    zoneCode: "5AL35002",
    zoneDescription: "AL Zip 35002",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AL35003",
    zoneCode: "5AL35003",
    zoneDescription: "AL Zip 35003",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
  {
    zoneId: "5AL35004",
    zoneCode: "5AL35004",
    zoneDescription: "AL Zip 35004",
    countryCode: "USA",
    state: null,
    geographicArea: null,
  },
];

export const mock_states = [
  {
    stateCode: "AC",
    stateName: "Australian Capital Territory",
    countryCode: "AUS",
  },
  {
    stateCode: "00",
    stateName: "DEFAULT",
    countryCode: "AUS",
  },
  {
    stateCode: "NS",
    stateName: "New South Wales",
    countryCode: "AUS",
  },
  {
    stateCode: "NT",
    stateName: "Northern Territory",
    countryCode: "AUS",
  },
  {
    stateCode: "QL",
    stateName: "Queensland",
    countryCode: "AUS",
  },
  {
    stateCode: "SA",
    stateName: "South Australia",
    countryCode: "AUS",
  },
  {
    stateCode: "TA",
    stateName: "Tasmania",
    countryCode: "AUS",
  },
  {
    stateCode: "VI",
    stateName: "Victoria",
    countryCode: "AUS",
  },
  {
    stateCode: "WA",
    stateName: "Western Australia",
    countryCode: "AUS",
  },
];

export const mock_carriers = [
  {
    carrierCode: "AACT",
    carrierDescription: "AAACooperTransportation",
    carrierTypeCodeDescription: null,
    scacCode: "AACT",
    scacCodeDescription: "AAACooperTransportation",
    divisionCode: null,
    carrierStatusEnumDescription: null,
  },
  {
    carrierCode: "ABFM",
    carrierDescription: "ABFLogistics",
    carrierTypeCodeDescription: null,
    scacCode: "OPEN",
    scacCodeDescription: "Open(SpotQuote)Carrier",
    divisionCode: null,
    carrierStatusEnumDescription: null,
  },
  {
    carrierCode: "ABFS",
    carrierDescription: "ABFFreight",
    carrierTypeCodeDescription: null,
    scacCode: "ABFS",
    scacCodeDescription: "ABFFreightSystem",
    divisionCode: null,
    carrierStatusEnumDescription: null,
  },
  {
    carrierCode: "ABMQ",
    carrierDescription: "ArcBest",
    carrierTypeCodeDescription: null,
    scacCode: "ABMQ",
    scacCodeDescription: "ArcBest",
    divisionCode: null,
    carrierStatusEnumDescription: null,
  },
];

export const mock_services = [
  {
    serviceCode: "8FHT",
    serviceDescription: "Truckload-Live",
    transitModeEnumDescription: "Road",
  },
  {
    serviceCode: "AACT",
    serviceDescription: "LTL",
    transitModeEnumDescription: "Road",
  },
  {
    serviceCode: "AADS",
    serviceDescription: "Truckload-FA-ADSJ",
    transitModeEnumDescription: "Road",
  },
  {
    serviceCode: "AAEQ",
    serviceDescription: "Truckload-FA-AEQC",
    transitModeEnumDescription: "Road",
  },
];

export const mock_transports = [
  {
    modeOfTransportCode: "1",
    modeOfTransport: "Air",
  },
  {
    modeOfTransportCode: "2",
    modeOfTransport: "Rail",
  },
  {
    modeOfTransportCode: "3",
    modeOfTransport: "Road",
  },
  {
    modeOfTransportCode: "4",
    modeOfTransport: "Ocean",
  },
  {
    modeOfTransportCode: "5",
    modeOfTransport: "Parcel",
  },
  {
    modeOfTransportCode: "6",
    modeOfTransport: "Truckload",
  },
  {
    modeOfTransportCode: "7",
    modeOfTransport: "LTL",
  },
];

export const mock_equipments = [
  {
    equipmentTypeCode: "*DFT",
    equipmentTypeDescription: "default",
  },
  {
    equipmentTypeCode: "1001",
    equipmentTypeDescription: "1001_Plan1_LTL",
  },
  {
    equipmentTypeCode: "1002",
    equipmentTypeDescription: "1002_99_PAL_MR_사용",
  },
  {
    equipmentTypeCode: "1003",
    equipmentTypeDescription: "1003_3_PAL_1톤_사용",
  },
  {
    equipmentTypeCode: "1005",
    equipmentTypeDescription: "1005_5_PAL_2.5톤_사용",
  },
  {
    equipmentTypeCode: "1007",
    equipmentTypeDescription: "1007_7_PAL_3.5톤_사용",
  },
  {
    equipmentTypeCode: "1010",
    equipmentTypeDescription: "1010_99_PAL_MR_사용",
  },
];

export const mock_charges = [
  {
    chargeCode: "1GST",
  },
  {
    chargeCode: "1HST",
  },
  {
    chargeCode: "1TAX",
  },
  {
    chargeCode: "1ZDP",
  },
  {
    chargeCode: "1ZHD",
  },
  {
    chargeCode: "1ZHO",
  },
  {
    chargeCode: "1ZHT",
  },
  {
    chargeCode: "1ZHZ",
  },
  {
    chargeCode: "1ZLP",
  },
  {
    chargeCode: "1ZLT",
  },
  {
    chargeCode: "1ZUD",
  },
];
export const Mock_drmtTableData = {
  onPage: 1,
  pageSize: 100,
  totalPages: 1,
  totalRecords: 8,
  drmMaintenanceDetails: [
    {
      id: 9526,
      sagaId: "dca99a23-1257-443d-a34d-200f5ca211a5",
      carrierScac: "AFXN",
      serviceScac: "AFXN",
      equipmentType: "53FT",
      itemType: "All Lots",
      item: "1",
      region: "Southeast",
      carrierManager: "Eric Mailahn",
      laneDescription: "ALALBERT-US_5AL36610",
      originCity: "ALBERTVILLE",
      originState: "AL",
      originCountry: "USA",
      destinationCity: "MOBILE",
      destinationState: "AL",
      destinationPostalCode: "36610",
      destinationCountry: "USA",
      primaryCustomers: "",
      estimatedMileagePcMiler: "312.1",
      annualShipmentVolume: "12",
      availableAnnualShipmentVolume: "12",
      annualMaxShipmentVolume: "12",
      bidRateWoFuel: "1,035.8",
      laneServiceType: "",
      incoterm: "",
      supplier: "AFXN - Amazon Logistics",
      transitTime: "",
      originPortCountry: "",
      originPort: "test",
      destinationTransportationMode: "TL",
      effectiveDate: null,
      expirationDate: null,
      tradeLane: "",
      originZone: "40072272",
      originPostalCode: "",
      destinationZone: null,
      destinationPort: "",
      destinationPortCountry: "",
      lineHaulChargeType: "NA_FLAT",
      lineHaulRate: "1,035.8",
      awardBackup: "Award",
      bucketType: null,
      qtyActiveFlag: null,
      minShipmentsAllocated: null,
      maxShipmentsAllocated: null,
      percentageActiveFlag: null,
      minCarrierAllocationPercentage: null,
      maxCarrierAllocationPercentage: null,
      baf: "",
      civa: "",
      ets: "",
      originZoneDesc: "test",
      originZoneShortDesc: "test",
      destinationZoneShortDesc: "test",
      changeComment: "test",
      destinationZoneDesc: "test",
      coupaFile: {
        id: 41,
        coupaFileName: "1751171450265_new sample domestic coupa file.xlsx",
        status: 0,
        coupaFileType: "DOMESTIC",
        domesticCoupaFileData: null,
      },
      status: 0,
      message: "Pending",
      coupaFileRecordErrors: ["12345"],
      tariffDetails: "test",
      tariffId: "AFXN-CST-TL",
      tariffNumber: "102294_fdee356f-7485-4757-8876-60b69e2dc187",
      versionNumber: 1,
    },
    {
      id: 9527,
      sagaId: "6666a5c8-1463-4b66-b226-70b79080b8a3",
      carrierScac: "ABFM",
      serviceScac: "8FHT",
      equipmentType: "53FT",
      itemType: "All Lots",
      item: "1",
      region: "Southeast",
      carrierManager: "Eric Mailahn",
      laneDescription: "ALALBERT-US_5AL36610",
      originCity: "ALBERTVILLE",
      originState: "AL",
      originCountry: "USA",
      destinationCity: "MOBILE",
      destinationState: "AL",
      destinationPostalCode: "36610",
      destinationCountry: "USA",
      primaryCustomers: "test",
      estimatedMileagePcMiler: "312.1",
      annualShipmentVolume: "12",
      availableAnnualShipmentVolume: "12",
      annualMaxShipmentVolume: "12",
      bidRateWoFuel: "1,035.8",
      laneServiceType: "",
      incoterm: "",
      supplier: "AFXN - Amazon Logistics",
      transitTime: "",
      originPortCountry: "",
      originPort: "",
      destinationTransportationMode: "TL",
      effectiveDate: null,
      expirationDate: null,
      tradeLane: "",
      originZone: "2061",
      originPostalCode: "",
      destinationZone: null,
      destinationPort: "",
      destinationPortCountry: "",
      lineHaulChargeType: "NA_FLAT",
      lineHaulRate: "1,035.8",
      awardBackup: "Award",
      bucketType: null,
      qtyActiveFlag: null,
      minShipmentsAllocated: null,
      maxShipmentsAllocated: null,
      percentageActiveFlag: null,
      minCarrierAllocationPercentage: null,
      maxCarrierAllocationPercentage: null,
      baf: "test",
      civa: "test",
      ets: "test",
      originZoneDesc: "",
      originZoneShortDesc: "",
      destinationZoneShortDesc: "",
      changeComment: "",
      destinationZoneDesc: "",
      coupaFile: {
        id: 42,
        coupaFileName: "1751171963762_new sample domestic coupa file.xlsx",
        status: 0,
        coupaFileType: "DOMESTIC",
        domesticCoupaFileData: null,
      },
      status: 0,
      message: "Pending",
      coupaFileRecordErrors: [
        {
          record: "carrierScac",
          errorMessage: "Invalid SCAC code",
        },
      ],
      tariffDetails: null,
      tariffId: "AFXN-CST-TL",
      tariffNumber: "102294",
      versionNumber: "",
    },
    {
      id: 9530,
      sagaId: "5af17304-f906-4f85-a92d-adfe6865afac",
      carrierScac: "AFXN",
      serviceScac: "AFXN",
      equipmentType: "53FT",
      itemType: "All Lots",
      item: "1",
      region: "Southeast",
      carrierManager: "Eric Mailahn",
      laneDescription: "ALALBERT-US_5AL36610",
      originCity: "ALBERTVILLE",
      originState: "AL",
      originCountry: "USA",
      destinationCity: "MOBILE",
      destinationState: "AL",
      destinationPostalCode: "36610",
      destinationCountry: "USA",
      primaryCustomers: null,
      estimatedMileagePcMiler: "312.1",
      annualShipmentVolume: "12",
      availableAnnualShipmentVolume: "12",
      annualMaxShipmentVolume: "12",
      bidRateWoFuel: "1,035.8",
      laneServiceType: "test",
      incoterm: "test",
      supplier: "AFXN - Amazon Logistics",
      transitTime: "test",
      originPortCountry: "",
      originPort: "",
      destinationTransportationMode: "TL",
      effectiveDate: "03/21/2026",
      expirationDate: "03/21/2026",
      tradeLane: "",
      originZone: "ALALBERT",
      originPostalCode: "",
      destinationZone: "US_5AL36610",
      destinationPort: "",
      destinationPortCountry: "",
      lineHaulChargeType: "NA_FLAT",
      lineHaulRate: "1,035.8",
      awardBackup: "Award",
      bucketType: "Weekly",
      qtyActiveFlag: "Yes",
      minShipmentsAllocated: "0",
      maxShipmentsAllocated: "1",
      percentageActiveFlag: "Yes",
      minCarrierAllocationPercentage: "100%",
      maxCarrierAllocationPercentage: "100%",
      baf: null,
      civa: null,
      ets: null,
      originZoneDesc: null,
      originZoneShortDesc: null,
      destinationZoneShortDesc: null,
      changeComment: null,
      destinationZoneDesc: null,
      coupaFile: {
        id: 45,
        coupaFileName: "1751269769492_new sample domestic coupa file.xlsx",
        status: 0,
        coupaFileType: "DOMESTIC",
        domesticCoupaFileData: null,
      },
      status: 200,
      message: "Success",
      coupaFileRecordErrors: [],
      tariffDetails: null,
      tariffId: "AFXN-CST-TL",
      tariffNumber: "102294",
      versionNumber: null,
    },
    {
      id: 9531,
      sagaId: "3e0d6354-808c-4edb-8386-97714dec58bc",
      carrierScac: "ABFM",
      serviceScac: "AFXN",
      equipmentType: "53FT",
      itemType: "All Lots",
      item: "1",
      region: "Southeast",
      carrierManager: "Eric Mailahn",
      laneDescription: "ALALBERT-US_5AL36610",
      originCity: "ALBERTVILLE",
      originState: "AL",
      originCountry: "USA",
      destinationCity: "MOBILE",
      destinationState: "AL",
      destinationPostalCode: "36610",
      destinationCountry: "USA",
      primaryCustomers: "",
      estimatedMileagePcMiler: "312.1",
      annualShipmentVolume: "12",
      availableAnnualShipmentVolume: "12",
      annualMaxShipmentVolume: "12",
      bidRateWoFuel: "1035.81",
      laneServiceType: "",
      incoterm: "",
      supplier: "AFXN - Amazon Logistics",
      transitTime: "",
      originPortCountry: "test",
      originPort: "",
      destinationTransportationMode: "TL",
      effectiveDate: null,
      expirationDate: null,
      tradeLane: "",
      originZone: "ALALBERT",
      originPostalCode: "",
      destinationZone: null,
      destinationPort: "",
      destinationPortCountry: "",
      lineHaulChargeType: "NA_FLAT",
      lineHaulRate: "1035.81",
      awardBackup: "Award",
      bucketType: null,
      qtyActiveFlag: null,
      minShipmentsAllocated: null,
      maxShipmentsAllocated: null,
      percentageActiveFlag: null,
      minCarrierAllocationPercentage: null,
      maxCarrierAllocationPercentage: null,
      baf: null,
      civa: null,
      ets: null,
      changeComment: null,
      coupaFile: {
        id: 46,
        coupaFileName: "1751275370465_new sample domestic coupa file.xlsx",
        status: 0,
        coupaFileType: "DOMESTIC",
        domesticCoupaFileData: null,
      },
      status: 0,
      message: "Pending",
      coupaFileRecordErrors: [],
      tariffDetails: null,
      tariffId: "AFXN-CST-TL",
      tariffNumber: "102294",
      versionNumber: 1,
    },
    {
      id: 9532,
      sagaId: "f07ce228-fb24-4bbd-a311-13a714158923",
      carrierScac: "AFXN",
      serviceScac: "AFXN",
      equipmentType: "53FT",
      itemType: "All Lots",
      item: "1",
      region: "Southeast",
      carrierManager: "Eric Mailahn",
      laneDescription: "ALALBERT-US_5AL36610",
      originCity: "ALBERTVILLE",
      originState: "AL",
      originCountry: "USA",
      destinationCity: "MOBILE",
      destinationState: "AL",
      destinationPostalCode: "36610",
      destinationCountry: "USA",
      primaryCustomers: null,
      estimatedMileagePcMiler: "312.1",
      annualShipmentVolume: "12",
      availableAnnualShipmentVolume: "12",
      annualMaxShipmentVolume: "12",
      bidRateWoFuel: "1035.81",
      laneServiceType: "",
      incoterm: "",
      supplier: "AFXN - Amazon Logistics",
      transitTime: "",
      originPortCountry: "test",
      originPort: "",
      destinationTransportationMode: "TL",
      effectiveDate: "03/21/2026",
      expirationDate: "03/21/2026",
      tradeLane: "test",
      originZone: "ALALBERT",
      originPostalCode: "test",
      destinationZone: "US_5AL36610",
      destinationPort: "test",
      destinationPortCountry: "test",
      lineHaulChargeType: "NA_FLAT",
      lineHaulRate: "1035.81",
      awardBackup: "Award",
      bucketType: "Weekly",
      qtyActiveFlag: "Yes",
      minShipmentsAllocated: "0",
      maxShipmentsAllocated: "1",
      percentageActiveFlag: "Yes",
      minCarrierAllocationPercentage: "100%",
      maxCarrierAllocationPercentage: "100%",
      baf: null,
      civa: null,
      ets: null,
      changeComment: null,
      coupaFile: {
        id: 47,
        coupaFileName: "1751342069067_new sample domestic coupa file.xlsx",
        status: 0,
        coupaFileType: "DOMESTIC",
        domesticCoupaFileData: null,
      },
      status: 5,
      message: null,
      coupaFileRecordErrors: [],
      tariffDetails: null,
      tariffId: "AFXN-CST-TL",
      tariffNumber: "102294_fea24f05-728e-490b-b145-5758f6ac2f68",
    },
    {
      id: 9533,
      sagaId: "cc590ca3-3442-4a40-8436-beb5766ff75d",
      carrierScac: "ABMQ",
      serviceScac: "AFXN",
      equipmentType: "53FT",
      itemType: "All Lots",
      item: "1",
      region: "Southeast",
      carrierManager: "Eric Mailahn",
      laneDescription: "ALALBERT-US_5AL36610",
      originCity: "ALBERTVILLE",
      originState: "AL",
      originCountry: "USA",
      destinationCity: "MOBILE",
      destinationState: "AL",
      destinationPostalCode: "36610",
      destinationCountry: "USA",
      primaryCustomers: "",
      estimatedMileagePcMiler: "312.1",
      annualShipmentVolume: "12",
      availableAnnualShipmentVolume: "12",
      annualMaxShipmentVolume: "12",
      bidRateWoFuel: "1,035.8",
      laneServiceType: "",
      incoterm: "",
      supplier: "AFXN - Amazon Logistics",
      transitTime: "",
      originPortCountry: "",
      originPort: "",
      destinationTransportationMode: "TL",
      effectiveDate: null,
      expirationDate: null,
      tradeLane: "",
      originZone: "ALALBERT",
      originPostalCode: "",
      destinationZone: null,
      destinationPort: "",
      destinationPortCountry: "",
      lineHaulChargeType: "NA_FLAT",
      lineHaulRate: "1,035.8",
      awardBackup: "Award",
      bucketType: null,
      qtyActiveFlag: null,
      minShipmentsAllocated: null,
      maxShipmentsAllocated: null,
      percentageActiveFlag: null,
      minCarrierAllocationPercentage: null,
      maxCarrierAllocationPercentage: null,
      baf: null,
      civa: null,
      ets: null,
      coupaFile: {
        id: 49,
        coupaFileName: "1751435689970_new sample domestic coupa file 1.xlsx",
        status: 0,
        coupaFileType: "DOMESTIC",
        domesticCoupaFileData: null,
      },
      status: 0,
      message: "Pending",
      coupaFileRecordErrors: [],
      tariffDetails: null,
      tariffId: "AFXN-CST-TL",
      tariffNumber: "102294_0a523fcc-ace8-4419-b966-56c30bb4c831",
    },
    {
      id: 9534,
      sagaId: null,
      carrierScac: null,
      serviceScac: null,
      equipmentType: null,
      itemType: null,
      item: null,
      region: null,
      carrierManager: null,
      laneDescription: null,
      originCity: null,
      originState: null,
      originCountry: null,
      destinationCity: null,
      destinationState: null,
      destinationPostalCode: null,
      destinationCountry: null,
      primaryCustomers: null,
      estimatedMileagePcMiler: null,
      annualShipmentVolume: null,
      availableAnnualShipmentVolume: null,
      annualMaxShipmentVolume: null,
      bidRateWoFuel: null,
      laneServiceType: null,
      incoterm: null,
      supplier: null,
      transitTime: null,
      originPortCountry: null,
      originPort: null,
      destinationTransportationMode: null,
      effectiveDate: null,
      expirationDate: null,
      tradeLane: null,
      originZone: null,
      originPostalCode: null,
      destinationZone: null,
      destinationPort: null,
      destinationPortCountry: null,
      lineHaulChargeType: null,
      lineHaulRate: null,
      awardBackup: null,
      bucketType: null,
      qtyActiveFlag: null,
      minShipmentsAllocated: null,
      maxShipmentsAllocated: null,
      percentageActiveFlag: null,
      minCarrierAllocationPercentage: null,
      maxCarrierAllocationPercentage: null,
      baf: null,
      civa: null,
      ets: null,
      coupaFile: {
        id: 49,
        coupaFileName: null,
        status: null,
        coupaFileType: null,
        domesticCoupaFileData: null,
      },
      status: null,
      message: null,
      coupaFileRecordErrors: null,
      tariffDetails: null,
      tariffId: null,
      tariffNumber: null,
    },
  ],
};
